import { io } from 'socket.io-client'

const BASE_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://api.anizone.co.il' // שים כאן את כתובת האתר שלך ב-Render
    // ? 'https://dev.anizone.co.il' // שים כאן את כתובת האתר שלך ב-Render
    : 'http://localhost:3030'

export const socketService = io(BASE_URL, {
  withCredentials: true,
})

socketService.on('connect', () => {
  // console.log('✅ Socket connected! ID:', socketService.id)
})

socketService.on('disconnect', () => {
  // console.log('❌ Socket disconnected!')
})
